export default __webpack_public_path__ + "static/media/pwa2.4bd0a71b.jpg";